var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "390px",
    height: "390px",
    viewBox: "0 0 390 390",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2AC51E7C-8B08-49B4-BBFC-6F5D72054110") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Screens",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Screen-/-Intro-/-Sprachauswahl"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 390,
    height: 844
  }), /*#__PURE__*/React.createElement("g", {
    id: "Screen-/-illustration-/-Benutzergruppe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55,69 L335,69 C346.045695,69 355,77.954305 355,89 L355,369 C355,380.045695 346.045695,389 335,389 L55,389 C43.954305,389 35,380.045695 35,369 L35,89 C35,77.954305 43.954305,69 55,69 Z",
    id: "Rectangle",
    fill: "#C2F1EA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "undraw_Around_the_world_re_n353",
    transform: "translate(20.000000, 65.630536)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.835558,115.905999 C291.8978,103.243578 265.369051,91.2683042 236.051719,83.0511375 C209.358215,75.5692003 183.322231,71.9569106 162.73425,72.8793783 L162.627078,70.4851368 C183.460309,69.5521315 209.766367,73.194748 236.698621,80.7434853 C266.289323,89.0373002 293.105478,101.153937 310.270708,113.986524 L308.835558,115.905999 Z",
    id: "Path",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.077301,125.659289 C307.092327,136.878028 304.740396,147.973742 300.175081,158.221582 C299.794004,159.079561 299.396966,159.929546 298.983965,160.771536 C282.633181,194.261295 245.335953,212.038959 209.024107,203.650758 C172.712261,195.262557 146.991319,162.927411 146.985923,125.659301 C146.985923,123.80673 147.049029,121.968555 147.175241,120.144776 C147.235168,119.217303 147.312664,118.29543 147.407729,117.379157 C151.816039,75.0103596 188.632872,43.5150033 231.173224,45.721063 C273.713576,47.9271227 307.075106,83.0617922 307.077301,125.659306 L307.077301,125.659289 Z",
    id: "Path",
    fill: "#A7D1CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.175104,158.221582 C299.794027,159.079561 299.396989,159.929546 298.983988,160.771536 C296.644926,161.025582 294.18284,161.210117 291.597729,161.325141 C289.457584,161.421005 287.255129,161.468943 285.004753,161.468943 C265.348028,161.468943 241.691421,157.840525 217.524344,151.067794 C190.591614,143.518582 166.225627,132.959271 148.912749,121.333488 C148.323191,120.938048 147.744021,120.541811 147.175241,120.144776 C147.235164,119.217303 147.31266,118.29543 147.407729,117.379157 C148.32562,118.033409 149.272264,118.688468 150.247661,119.344334 C167.356814,130.831129 191.478368,141.277805 218.171443,148.759928 C242.127588,155.475121 265.561346,159.07239 284.992778,159.07239 C287.214392,159.07239 289.3801,159.025253 291.489903,158.93098 C294.562331,158.79197 297.457398,158.555504 300.175104,158.221582 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.005077,159.552121 C265.348949,159.552121 241.690951,155.92379 217.524941,149.150417 C190.592483,141.601674 166.225436,131.041975 148.912401,119.416493 C131.238018,107.548408 122.950152,95.8540986 125.575376,86.4877809 C128.200506,77.1214748 141.359088,71.4382615 162.627044,70.4851368 L162.734216,72.8793783 C152.802342,73.3244031 144.708284,74.8006259 138.676947,77.2669392 C132.660249,79.7271755 129.028611,83.0471577 127.882993,87.1346831 C126.73737,91.2220869 128.114462,95.9458437 131.9759,101.174897 C135.846805,106.416584 141.994601,111.884486 150.248397,117.426817 C167.355591,128.914116 191.477939,139.360995 218.171832,146.842811 C242.128584,153.557431 265.560269,157.155579 284.993364,157.156037 C287.213714,157.156037 289.378976,157.108839 291.48915,157.014443 C301.421122,156.569296 309.515179,155.093195 315.546673,152.626882 C321.563371,150.166645 325.19501,146.846785 326.340627,142.759259 C328.397618,135.419751 322.18103,125.883053 308.835552,115.905993 L310.270708,113.986634 C317.138167,119.120779 322.221761,124.18156 325.380365,129.028084 C328.76647,134.224012 329.865951,139.061632 328.648279,143.406127 C326.02305,152.772433 312.864347,158.455403 291.596611,159.408661 C289.456518,159.504618 287.255366,159.552121 285.005077,159.552121 Z",
    id: "Path",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F2F2F2",
    cx: 229.149073,
    cy: 30.2600808,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#CCCCCC",
    cx: 107.461274,
    cy: 69.4016098,
    r: 1.57797841
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#CCCCCC",
    cx: 104.09804,
    cy: 131.162755,
    r: 3.11726481
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#CCCCCC",
    cx: 291.215965,
    cy: 35.7635463,
    r: 2.07757986
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#CCCCCC",
    cx: 364.901289,
    cy: 121.990308,
    r: 3.37318593
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#CCCCCC",
    cx: 338.524643,
    cy: 68.1150873,
    r: 1.44725166
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#CCCCCC",
    cx: 162.801711,
    cy: 49.5222216,
    r: 2.25775638
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#CCCCCC",
    cx: 333.459268,
    cy: 115.150534,
    r: 1.44725166
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#CCCCCC",
    cx: 111.436002,
    cy: 175.190513,
    r: 1.80129605
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#CCCCCC",
    cx: 147.82004,
    cy: 200.261861,
    r: 1.95069971
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#CCCCCC",
    points: "204.527297 3.84950496 200.677792 3.84950496 200.677792 -4.97379915e-14 198.612558 -4.97379915e-14 198.612558 3.84950496 194.761315 3.84950496 194.761315 5.91647768 198.612558 5.91647768 198.612558 9.76598264 200.677792 9.76598264 200.677792 5.91647768 204.527297 5.91647768"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#CCCCCC",
    points: "293.823068 212.143351 291.405034 212.143351 291.405034 209.726476 290.108542 209.726476 290.108542 212.143351 287.691667 212.143351 287.691667 213.440423 290.108542 213.440423 290.108542 215.857298 291.405034 215.857298 291.405034 213.440423 293.823068 213.440423"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#CCCCCC",
    points: "349.612793 199.771059 347.80593 199.771059 347.80593 197.964196 346.835588 197.964196 346.835588 199.771059 345.028725 199.771059 345.028725 200.741401 346.835588 200.741401 346.835588 202.548264 347.80593 202.548264 347.80593 200.741401 349.612793 200.741401"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    opacity: 0.1,
    cx: 228.231848,
    cy: 62.9808962,
    r: 6.72646102
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    opacity: 0.1,
    cx: 176.560386,
    cy: 112.206361,
    r: 6.72646102
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    opacity: 0.1,
    cx: 250.857211,
    cy: 179.77673,
    r: 6.72646102
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    opacity: 0.1,
    cx: 228.231848,
    cy: 122.601809,
    r: 6.72646102
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    opacity: 0.1,
    cx: 179.923608,
    cy: 159.597342,
    r: 6.72646102
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    opacity: 0.1,
    cx: 264.310138,
    cy: 86.5235127,
    r: 6.72646102
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    opacity: 0.1,
    cx: 286.629748,
    cy: 132.080003,
    r: 6.72646102
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 228.231848,
    cy: 93.2499795,
    r: 8.86670468
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.231848,80.4085291 C221.308596,80.4085291 215.696191,86.0209338 215.696191,92.9441857 C215.696191,99.8674436 228.231848,122.601763 228.231848,122.601763 C228.231848,122.601763 240.767505,99.8674436 240.767505,92.9441857 C240.767505,86.0209338 235.1551,80.4085291 228.231848,80.4085291 Z M228.231848,99.059175 C225.0235,99.059175 222.422629,96.4582848 222.422629,93.249937 C222.422629,90.0415892 225.023516,87.4407144 228.231863,87.4407144 C231.440211,87.4407144 234.04109,90.0415969 234.04109,93.2499447 C234.04109,94.7906513 233.42905,96.2682553 232.339605,97.3576984 C231.25016,98.4471414 229.772555,99.059175 228.231848,99.059175 L228.231848,99.059175 L228.231848,99.059175 Z",
    id: "Shape",
    fill: "#07E1BE"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 179.923608,
    cy: 131.162755,
    r: 8.86669309
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.923608,118.321327 C173.000356,118.321327 167.387951,123.933732 167.387951,130.856984 C167.387951,137.780242 179.923608,160.514555 179.923608,160.514555 C179.923608,160.514555 192.459264,137.780242 192.459264,130.856984 C192.459264,127.532321 191.138547,124.343828 188.787656,121.992936 C186.436764,119.642045 183.248271,118.321327 179.923608,118.321327 Z M179.923608,136.971967 C176.715259,136.971967 174.114389,134.371076 174.114389,131.162728 C174.114389,127.954379 176.715279,125.353507 179.923627,125.353507 C183.131976,125.353507 185.73285,127.954394 185.73285,131.162743 C185.73285,132.703449 185.12081,134.181052 184.031365,135.270495 C182.941919,136.359937 181.464314,136.971967 179.923608,136.971967 L179.923608,136.971967 Z",
    id: "Shape",
    fill: "#07E1BE"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 286.629748,
    cy: 103.645416,
    r: 8.86670468
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.629771,90.8039884 C283.305102,90.8039884 280.116604,92.1247103 277.765711,94.4756095 C275.414818,96.8265086 274.094114,100.015011 274.094114,103.33968 C274.094114,110.262938 286.629771,132.997251 286.629771,132.997251 C286.629771,132.997251 299.165428,110.262938 299.165428,103.33968 C299.165428,100.015011 297.844724,96.8265086 295.493831,94.4756095 C293.142938,92.1247103 289.95444,90.8039884 286.629771,90.8039884 Z M286.629771,109.454628 C283.421423,109.454628 280.820558,106.853732 280.820558,103.645385 C280.820558,100.437037 283.42145,97.8361679 286.629798,97.8361679 C289.838146,97.8361679 292.439019,100.437056 292.439019,103.645404 C292.439019,105.18611 291.826979,106.663713 290.737533,107.753156 C289.648088,108.842598 288.170483,109.454628 286.629777,109.454628 L286.629771,109.454628 Z",
    id: "Shape",
    fill: "#07E1BE"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 228.231848,
    cy: 33.629061,
    r: 8.86670468
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.231848,20.7876396 C221.308603,20.7876396 215.696191,26.4000509 215.696191,33.3232962 C215.696191,40.2465599 228.231848,62.9808788 228.231848,62.9808788 C228.231848,62.9808788 240.767505,40.2465599 240.767505,33.3232962 C240.767505,29.9986333 239.446787,26.81014 237.095896,24.4592484 C234.745004,22.1083568 231.556511,20.7876396 228.231848,20.7876396 L228.231848,20.7876396 Z M228.231848,39.4382855 C225.0235,39.4382855 222.422629,36.8373953 222.422629,33.6290475 C222.422629,30.4206997 225.023516,27.8198249 228.231863,27.8198249 C231.440211,27.8198249 234.04109,30.4207074 234.04109,33.6290552 C234.04109,35.1697618 233.42905,36.6473658 232.339605,37.7368088 C231.25016,38.8262518 229.772555,39.4382855 228.231848,39.4382855 L228.231848,39.4382855 Z",
    id: "Shape",
    fill: "#07E1BE"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 250.857211,
    cy: 151.342143,
    r: 8.86670468
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.857211,138.500716 C243.933959,138.500716 238.321554,144.113121 238.321554,151.036373 C238.321554,157.959631 250.857211,180.693944 250.857211,180.693944 C250.857211,180.693944 263.392867,157.959631 263.392867,151.036373 C263.392867,147.71171 262.07215,144.523217 259.721258,142.172325 C257.370367,139.821433 254.181873,138.500716 250.857211,138.500716 L250.857211,138.500716 Z M250.857211,157.151362 C247.648863,157.151362 245.047992,154.550472 245.047992,151.342124 C245.047992,148.133776 247.648878,145.532902 250.857226,145.532902 C254.065574,145.532902 256.666452,148.133784 256.666452,151.342132 C256.666452,152.882838 256.054413,154.360442 254.964968,155.449885 C253.875522,156.539328 252.397917,157.151362 250.857211,157.151362 Z",
    id: "Shape",
    fill: "#394854"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 176.560386,
    cy: 83.1602793,
    r: 8.86670468
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.560392,70.3188637 C169.63714,70.3188637 164.024735,75.9312683 164.024735,82.8545202 C164.024735,89.7777782 176.560392,112.512097 176.560392,112.512097 C176.560392,112.512097 189.096048,89.7777782 189.096048,82.8545202 C189.096048,75.9312683 183.483644,70.3188637 176.560392,70.3188637 L176.560392,70.3188637 Z M176.560392,88.9695038 C173.352043,88.9695038 170.751167,86.3686182 170.751167,83.1602696 C170.751167,79.9519211 173.352051,77.3510432 176.5604,77.3510432 C179.768748,77.3510432 182.369628,79.9519249 182.369628,83.1602735 C182.369628,84.7009786 181.757587,86.1785808 180.668143,87.2680233 C179.5787,88.3574659 178.101097,88.9695038 176.560392,88.9695038 Z",
    id: "Shape",
    fill: "#394854"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 264.310138,
    cy: 58.394673,
    r: 8.86670468
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.310115,45.5532748 C257.386863,45.5532748 251.774459,51.1656794 251.774459,58.0889314 C251.774459,65.0121951 264.310115,87.7465082 264.310115,87.7465082 C264.310115,87.7465082 276.845772,65.0121893 276.845772,58.0889256 C276.845772,51.1656759 271.233365,45.5532748 264.310115,45.5532748 Z M264.310115,64.2039207 C261.101767,64.2039207 258.500891,61.6030351 258.500891,58.3946865 C258.500891,55.186338 261.101774,52.5854601 264.310123,52.5854601 C267.518472,52.5854601 270.119351,55.1863419 270.119351,58.3946904 C270.119351,61.603032 267.518457,64.2039207 264.310115,64.2039207 L264.310115,64.2039207 L264.310115,64.2039207 Z",
    id: "Shape",
    fill: "#394854"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFB8B8",
    points: "91.1744678 264.022058 97.0554145 263.354405 97.2798966 240.353927 88.600407 241.339234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0694464,261.413137 L108.670434,261.413137 L108.670434,268.599878 L97.2561835,268.599878 C93.2870582,268.599878 90.0694464,265.382267 90.0694464,261.413137 L90.0694464,261.413137 L90.0694464,261.413137 Z",
    id: "Path",
    fill: "#394854",
    transform: "translate(99.369940, 265.006507) rotate(173.525940) translate(-99.369940, -265.006507) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFB8B8",
    points: "30.6946607 263.65468 36.6132625 263.654197 39.4287018 240.825581 30.6936952 240.826063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4265993,261.96328 L48.027582,261.96328 L48.027582,269.150022 L36.6133364,269.150022 C32.6442111,269.150022 29.4265993,265.93241 29.4265993,261.96328 L29.4265993,261.96328 L29.4265993,261.96328 Z",
    id: "Path",
    fill: "#394854",
    transform: "translate(38.727091, 265.556651) rotate(179.997380) translate(-38.727091, -265.556651) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1587218,161.567006 L76.5380214,172.559013 L94.8827904,212.256499 L99.7103612,249.911552 L88.6069484,250.394309 L81.8483492,215.635799 L58.6760094,190.532431 L38.400212,256.187394 L29.2278275,255.22188 C29.2278275,255.22188 36.9519407,170.256633 47.5725965,161.567006 C47.5725965,161.567006 64.9518514,153.360135 73.1587218,161.567006 Z",
    id: "Path",
    fill: "#394854"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFB8B8",
    cx: 58.1685448,
    cy: 102.281009,
    r: 11.8570111
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3656145,163.739413 C74.3656145,163.739413 75.8138857,114.498191 55.5380883,117.87749 C35.262291,121.25679 43.7105399,168.808362 43.7105399,168.808362 C43.7105399,168.808362 48.0553536,177.49799 58.6760094,167.842848 C69.2966651,158.187706 74.3656145,163.739413 74.3656145,163.739413 Z",
    id: "Path",
    fill: "#C8D7F2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.2,
    points: "46.3659211 138.636045 51.1370093 156.924331 58.4058826 164.193687 48.2969494 160.84287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5154188,184.564718 C73.1647937,184.075016 72.1004469,183.012221 71.6087741,181.662312 C71.1171012,180.312403 71.2486085,178.814047 71.9679097,177.570422 L60.6912498,164.515054 L69.5809125,163.357938 L78.9265393,175.932935 C80.9807468,177.310025 81.6803234,180.005903 80.5549348,182.208095 C79.4295461,184.410286 76.8349078,185.422718 74.5154285,184.564718 L74.5154188,184.564718 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7856385,127.90714 L62.0552896,152.877378 L77.0207591,172.187662 L70.7449171,177.015232 L50.4691197,156.739435 C50.4691197,156.739435 43.2277635,132.118824 48.5380914,124.877468 C50.5294643,122.161959 52.7245028,121.415192 54.6904152,121.54248 C58.0375183,121.821191 60.6518784,124.551118 60.7856385,127.90714 Z",
    id: "Path",
    fill: "#C8D7F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7583534,114.739666 C56.8731721,114.636747 56.9327622,114.485728 56.9191593,114.332136 C56.9055563,114.178544 56.8203519,114.040349 56.6892323,113.959212 C54.5444846,112.63097 53.2962941,110.237514 53.4347377,107.718586 C53.5731813,105.199658 55.0761562,102.957409 57.3535495,101.872215 C60.8395673,100.210126 65.5633405,101.503176 68.1403412,98.3092794 C69.2008243,96.9265359 69.6066375,95.150548 69.251957,93.4444397 C68.6959077,90.4278163 66.4281177,88.1875531 63.8884052,86.6522455 C57.5237881,82.8047188 49.5256973,82.9087486 43.2633047,86.9205127 C37.0009121,90.9322769 33.5627775,98.1544309 34.3972048,105.544664 C34.7250258,108.448023 35.6208926,111.703573 33.8945146,114.060813 C32.375114,116.135437 29.5071459,116.524447 26.9878394,117.039945 C21.5842767,118.145609 16.3712147,120.696294 12.7042498,124.816293 C9.03728496,128.936291 7.08106638,134.716786 8.18666699,140.120363 C9.2922676,145.52394 13.7277817,150.272788 19.1793402,151.110357 C23.6166743,151.792102 28.1985314,149.907664 31.4570693,146.819511 C34.7156072,143.731357 36.7753096,139.561094 38.0744765,135.263779 C39.616475,130.163243 40.2247248,124.667082 43.0086545,120.123628 C45.7329107,115.677571 51.6036326,112.490447 56.2047807,114.805938 C56.3852981,114.900215 56.6051917,114.873889 56.7583534,114.739666 L56.7583534,114.739666 Z",
    id: "Path",
    fill: "#394854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.689181,269.750821 L0.482757081,269.750821 C0.216137707,269.750821 0,269.534683 0,269.268064 C0,269.001444 0.216137707,268.785307 0.482757081,268.785307 L148.689181,268.785307 C148.9558,268.785307 149.171938,269.001444 149.171938,269.268064 C149.171938,269.534683 148.9558,269.750821 148.689181,269.750821 Z",
    id: "Path",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.d851ae3c94b77009bd724c324ab8ef49.svg";
export { ForwardRef as ReactComponent };